// UC1 — compact "AC" mark for the collapsed sidebar.
// Same Alkeme gold (#ffbf3b, from alkeme-marketing's globals.css
// --color-gold token) as LogoFull's "Alkeme" wordmark — keeps the
// brand identity consistent across expanded and collapsed states.

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    display: 'block',
  },
  letters: {
    fill: '#ffbf3b',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 32"
    >
      <text
        x="20"
        y="26"
        textAnchor="middle"
        fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontSize="26"
        fontWeight="700"
        letterSpacing="-1"
        className={classes.letters}
      >
        IT
      </text>
    </svg>
  );
};
